module.exports = __webpack_public_path__ + "media/images/views/home/home-features-photo-4-fa04d35d3c209af3927923101dc0261a.png";